import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeOneComponent } from "./components/pages/home-one/home-one.component";

const routes: Routes = [
    { path: "", component: HomeOneComponent },
    {
        path: "**",
        redirectTo: "",
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            anchorScrolling: "enabled",
            scrollPositionRestoration: "disabled",
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
